import React, { ReactNode } from 'react'
import {
  DialogRoot,
  DialogOverlay,
  DialogPortal,
  DialogContent,
} from './styled'

interface ModalProps {
  open: boolean | boolean
  setIsOpenController: () => void
  top: string
  left: string
  height: string
  width: string
  borderradius: string
  backgroundcolor: string
  padding?: string
  children?: ReactNode
}

export const ModalRoot = ({
  open,
  setIsOpenController,
  top,
  left,
  height,
  width,
  borderradius,
  children,
  backgroundcolor,
  padding,
}: ModalProps) => {
  return (
    <DialogRoot open={open} onOpenChange={setIsOpenController}>
      <DialogPortal>
        <DialogOverlay aria-hidden="true" />
        <DialogContent
          top={top}
          left={left}
          height={height}
          width={width}
          borderradius={borderradius}
          backgroundcolor={backgroundcolor}
          padding={padding}
        >
          {children}
        </DialogContent>
      </DialogPortal>
    </DialogRoot>
  )
}
